import { Box, Typography, useTheme } from '@mui/material'
import CellHOC from '@platform/react/hoc/list/cell'
import { def } from 'lib/util'
import settings from '@tenant/settings'
import Icon from 'ui/Element/Icon'

const styles = theme => ({
  validation: {
    color: theme.palette.signal.main,
  },
  subRow: {
    gap: '0.3125rem',
    display: 'flex',
    alignItems: 'center',
  },
  partsAvailable: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
  },
})
/**
 * Displays the name, serial and current state (whether it has an equipment and a product) of a
 * ServiceItem.
 *
 * @param {Object} props    element's properties
 * @param {Object} classes  element's style classes
 *
 * @returns {JSX.Element}
 */
const ListItemCellDeviceWithSerial = (classes, props = {}) => {
  const theme = useTheme()
  const {
    acl,
    name,
    serial,
    serialDistinction,
    product,
    equipment,
    toBeValidated,
    inverted = false,
    toBeValidatedInfo,
    partsAvailable: partsAvailableLabel,
    notConfirmed,
  } = props

  const { partsAvailable } = equipment?.value || {}

  const status = []
  !equipment && !settings.suppressEquipmentDevices && status.push(props.noEquipment)
  !product && !settings.suppressProductDevices && status.push(props.noProduct)
  notConfirmed && status.push(props.notConfirmedLabel)

  const displayValidation = def(toBeValidated) && acl !== false

  const aboveValue = !inverted ? name : serialDistinction ?? serial
  const belowValue = !inverted ? serialDistinction ?? serial : name

  return <>
    <Typography
      title={aboveValue}
      color={'black'}
      variant={'body2'}
      className={classes.row}
      sx={{ fontWeight: 700 }}
    >
      {aboveValue}
    </Typography>
    <Typography
      title={belowValue}
      variant={'caption'}
      className={classes.row}
      color={theme.palette.text.disabled}
    >
      {belowValue}
    </Typography>
    <Box className={classes.subRow}>
      {status.map((item, index) => (
        <Typography
          key={index}
          variant={'caption'}
          className={classes.row}
          color={theme.palette.warning.main}
        >
          {item}
        </Typography>
      )).reduce((result, item) => (result.length ? [result, ' ● ', item] : [item]), [])}
    </Box>
    {!displayValidation ? null : (
      <Typography
        variant={'caption'}
        title={toBeValidatedInfo}
        className={`${classes.row} ${classes.validation}`}
      >
        {toBeValidatedInfo}
      </Typography>
    )}
    {partsAvailable === false && settings.showEquipmentPartsAvailable ? (
      <Box className={classes.partsAvailable}>
        <Icon
          name={'alert-triangle'}
          color={'warning'}
          size={'1rem'}
        />
        <Typography
          color={theme.palette.warning.main}
          variant={'12/medium'}
        >
          {partsAvailableLabel}
        </Typography>
      </Box>
    ) : null}
  </>
}

export default CellHOC(ListItemCellDeviceWithSerial, styles)
